<template>
  <div class="checkout">
    <div class="container">
      <ul class="breadcrumb">
          <li class="breadcrumb-item">
              <router-link :to="{name: 'Home'}">Página Principal</router-link>
          </li>
          <li class="breadcrumb-item">
              <span>Pagamento</span>
          </li>
      </ul>
      <div class="element-wrapper pb-2">
        <h3>Compra Dr.Achei Card</h3>
      </div>      
      <div class="element-box">
        <div class="row">
          <div class="col-md-8 col-12">
            <div class="row">
              <div class="col-12">
                <div class="element-wrapper">
                  <h6 class="element-header">
                    Detalhes do titular
                  </h6>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="label">Nome Titular</div>
                      <h6>{{cartao.client.name}}</h6>
                    </div>
                    <div class="col-md-6 col-6">
                      <div class="label">E-mail</div>
                      <h6>{{cartao.client.email}}</h6>
                    </div>
                    <div class="col-md-2 col-6">
                      <div class="label">Sexo</div>
                      <h6>{{cartao.client.sexo}}</h6>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-6 col-xs-6">
                      <div class="label">Estado Civil</div>
                      <h6>Casado</h6>
                    </div>
                    <div class="col-6">
                      <div class="label">CPF</div>
                      <h6>{{cartao.client.cpf}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">Naturalidade</div>
                      <h6>{{cartao.client.naturalidade}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">Estado</div>
                      <h6>{{cartao.client.ufNaturalidade}}</h6>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col">
                      <div class="label">Celular</div>
                      <h6>{{cartao.client.telefoneCelular}}</h6>
                    </div>
                    <div class="col">
                      <div class="label">Data de nascimento</div>
                      <h6>{{getDataFormatada(cartao.client.dataNascimento)}}</h6>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col">
                      <label for="">Endereço</label>
                      <h6>{{cartao.client.enderecoResidencial}}</h6>
                    </div>
                    <div class="col-md-2 col-3">
                      <label for="">Número</label>
                      <h6>{{cartao.client.enderecoNumero}}</h6>
                    </div>
                    <div class="col-md-5 col-xs-12">
                      <label for="">Complemento</label>
                      <h6>{{cartao.client.enderecoComplemento}}</h6>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col">
                      <label for="">Bairro</label>
                      <h6>{{cartao.client.bairro}}</h6>
                    </div>
                    <div class="col-md-3 col-xs-6">
                      <label for="">Cidade</label>
                      <h6>{{cartao.client.cidade}}</h6>
                    </div>
                    <div class="col-1">
                      <label for="">UF</label>
                      <h6>{{cartao.client.uf}}</h6>
                    </div>
                    <div class="col-md-3 col-xs-6">
                      <label for="">CEP</label>
                      <h6>{{cartao.client.cep}}</h6>
                    </div>
                  </div>
                  
                </div>
                <br>
                <div class="element-wrapper" v-if="cartao.client.dependentes && cartao.client.dependentes.length > 0">
                    
                    <h6 class="element-header">
                      Dependentes
                    </h6>
                    <div class="row"
                      v-for="dependente in cartao.client.dependentes"
                      :key="dependente.cpf">
                      <div class="col-12">
                        <label for="">Nome</label>
                        <h6>{{dependente.name}}</h6>
                      </div>
                      <div class="col-md-6 col-6">
                        <label for="">CPF</label>
                        <h6>{{dependente.cpf}}</h6>
                      </div>
                      <div class="col-md-3 col-6">
                        <label for="">Data de Nascimento</label>
                        <h6>{{dependente.dataNascimento}}</h6>
                      </div>
                    </div>
                  </div>
                <br>
                <div class="element-wrapper">
                  <h6 class="element-header">
                    Dados de Pagamento
                  </h6>
                  <div class="os-tabs-w">
                    <div class="os-tabs-controls">
                      <ul class="nav nav-tabs nav-fill">
                        <li class="nav-item">
                          <a class="nav-link active show" data-toggle="tab" href="#tab_credit" @click="paymentMethod = 'cartao'">
                            <i class="far fa-credit-card"></i>
                            <p>Cartão de crédito</p>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" data-toggle="tab" href="#tab_boleto" @click="paymentMethod = 'boleto'">
                            <i class="fas fa-barcode"></i>
                            <p>Boleto</p></a>
                        </li>
                        
                      </ul>
                    </div>
                    <div class="tab-content">
                      <div class="tab-pane active show" id="tab_credit">
                        <form @submit.prevent="pagarComCredito">
                          <div class="form-desc">
                            <i class="fas fa-lock"></i> Compra Segura
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for=""> Número do Cartão</label>
                            <div class="col-sm-8">
                              <img :src="bandeira" alt="bandeira-cartao" height="50"><input class="form-control form-control-lg" placeholder="Digite apenas os números" type="tel" v-model="card.card_number" v-card v-mask="'#### #### #### ####'" required>
                              <small>Sem pontos, espaços e hífens</small>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for=""> Nome impresso no cartão</label>
                            <div class="col-sm-8">
                              <input class="form-control" placeholder="Digite o nome" type="text" v-model="card.holder_name" required>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for="">Validade</label>
                            <div class="col-md-4 col-6">
                              <input class="form-control" placeholder="Mês com 2 dígitos. Ex. 03" type="tel" v-model="card.expiration_month" minlength="2" maxlength="2" size="4" v-mask="'##'" required>
                            </div>
                            <div class="col-md-4 col-6">
                              <input class="form-control" placeholder="Ano com 4 dígitos. Ex. 2019" type="tel" v-model="card.expiration_year" minlength="4" maxlength="4" size="4" v-mask="'####'" required>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="col-form-label col-sm-4 text-right" for=""> Código de Segurança</label>
                            <div class="col-sm-8">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" id="validationTooltipUsernamePrepend"><a href="#"><i class="far fa-question-circle"></i></a></span>
                                </div>
                                <input type="tel" class="form-control" id="validationTooltipUsername" aria-describedby="validationTooltipUsernamePrepend" required v-model="card.security_code" minlength="3" maxlength="3" placeholder="Com 3 dígitos. Ex. 123">
                                <div class="invalid-tooltip">
                                  Please choose a unique and valid username.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-buttons-w">
                            <button class="btn btn-primary btn-lg" type="submit"> Finalizar Compra</button>
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" id="tab_boleto">
                        <div class="alert alert-warning" role="alert">
                          <strong>Atenção! </strong>Só emitimos boleto do Banco Bradesco. Confira os dados antes de paga-lo.
                        </div>
                        <div class="content-box">
                          <div class="row">
                          <div class="col"><h5 class="text-center">Imprima o boleto e pague no banco</h5></div>
                          <div class="col"><h5 class="text-center">Ou pague pela internet usando o codigo de barras</h5></div>
                          <div class="col"><h5 class="text-center">O boleto será compensado em até 2 dias úteis.</h5></div>
                        </div>
                        </div>
                        <div class="row">
                          <div class="col col-md-4">
                            <label>Dia para Pagamento</label>
                            <select class="form-control" v-model="dia_pagamento">
                              <option :value="5">5</option>
                              <option :value="10">10</option>
                              <option :value="15">15</option>
                              <option :value="20">20</option>
                              <option :value="25">25</option>
                              <option :value="30">30</option>
                            </select>
                          </div>
                          <div class="col">
                            <button class="btn btn-primary btn-lg" type="button" @click="pagarComBoleto"> Pagar com Boleto</button>
                          </div>
                        </div>
                        <br>
                        <div class="content-box">
                          <label for="">Importante</label>
                          <ul>
                            <li>Caso o seu computador tenha um programa anti pop-up, será preciso desativá-lo antes de finalizar sua compra e imprimir o boleto ou pagar pelo internet banking;</li>
                            <li>Não faça depósito ou transferência entre contas. O boleto não é enviado pelos Correios. Imprima-o e pague-o no banco ou pela internet;</li>
                            <li>Se o boleto não for pago até a data de vencimento, o pedido será automaticamente cancelado;</li>
                            <li>O prazo de entrega dos pedidos pagos com boleto bancário começa a contar três dias depois do pagamento do boleto, tempo necessário para que a instituição bancária confirme o pagamento.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
        
            </div>
          </div>
          <div class="col-3 offset-md-1">
            <div class="element-wrapper sticky">
                <h6 class="element-header">
                  Resumo da Compra
                </h6>
                <table class="table table-clean">
                  <tbody>
                    <tr>
                      <td>
                        <div class="value">
                          Plano: <b>{{cartao.plano.name}}</b>
                        </div>
                        <span class="sub-value"></span>
                      </td>
                      <td class="text-right">
                        <div class="value">
                          {{ (cartao.plano.price || 0) | money}} / mês
                        </div>
                      </td>
                    </tr>

                    <!-- <tr v-if="cartao.plano.name === 'Dr Achei Card (Anual)'">
                      <td>
                        <div class="value">
                          Promoção
                        </div>
                        <span class="sub-value"></span>
                      </td>
                      <td class="text-right">
                        <div class="value text-success">
                          - {{ cartao.plano.price | money }}
                        </div>
                      </td>
                    </tr> -->

                    <tr>
                      <td>
                        <div class="value">
                          <h6>Total</h6>
                        </div>
                        
                      </td>
                      <td class="text-right">
                        <div class="value">
                          <!-- <h6 v-if="cartao.plano.name === 'Dr Achei Card (Anual)'">{{ 0 | money }}</h6> -->
                          <h6>{{ valorTotalPlano | money }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- <banner-promocao-planos v-if="cartao.plano.name === 'Dr Achei Card (Anual)'"></banner-promocao-planos> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import BannerPromocaoPlanos from '@/components/BannerPromocaoPlanos'

export default {
  components: {
    BannerPromocaoPlanos
  },

  data () {
    return {
      paymentMethod: 'cartao',
      bandeira: require('@/assets/images/cartao_vazio.png'),
      cartao: null,
      loading: false,
      selectedPlan: null,
      selectedPurchase: null,
      isParcelado: false,
      qtdParcelas: null,
      dia_pagamento: 5,
      customer: {
        first_name: '',
        last_name: '',
        taxpayer_id: '',
        description: '',
        email: '',
        address: {
          line1: '',
          line2: '',
          neighborhood: '',
          city: '',
          state: '',
          postal_code: '',
          country_code: 'BR'
        }
      },
      card: {
        holder_name: '',
        expiration_month: '',
        expiration_year: '',
        security_code: '',
        card_number: ''
      }
    }
  },

  computed: {
    validationsCustomer () {
      return {
        first_name: !!this.customer.first_name,
        last_name: !!this.customer.last_name,
        taxpayer_id: !!this.customer.taxpayer_id,
        description: !!this.customer.description,
        email: !!this.customer.email
      }
    },

    isCustomerValid () {
      const validations = this.validationsCustomer
      return Object.keys(validations).every(key => validations[key])
    },

    validationsCard () {
      return {
        holder_name: !!this.card.holder_name,
        expiration_month: !!this.card.expiration_month && this.card.expiration_month.length === 2,
        expiration_year: !!this.card.expiration_year && this.card.expiration_year.length === 4,
        security_code: !!this.card.security_code && this.card.security_code.length === 3,
        card_number: !!this.card.card_number
      }
    },

    isCardValid () {
      const validations = this.validationsCard
      return Object.keys(validations).every(key => validations[key])
    },

    valorTotalPlano () {
      let total = 0

      total = this.cartao.plano.price || 0

      return total
    }
  },

  watch: {
    'customer.first_name' () {
      this.customer.description = this.customer.first_name + ' ' + this.customer.last_name
    },

    'customer.last_name' () {
      this.customer.description = this.customer.first_name + ' ' + this.customer.last_name
    }
  },

  methods: {
    async pagarComBoleto () {
      try {
        this.$store.dispatch('setLoading', true)

        const paymentPayload = {
          plan_id: this.$route.query.k,
          saude_id: this.$route.query.id,
          customer: this.customer,
          'dia_pagamento': this.dia_pagamento
        }

        const response = await this.$store.dispatch('comprarPlanoComBoleto', paymentPayload)
        const url = response.data.payment_method.url
        this.$store.dispatch('showSuccessMsg', { body: 'Compra realizada com sucesso' })
        window.open(url)
      } catch (error) {
        console.log(error.message)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async pagarComCredito () {
      try {
        this.$store.dispatch('setLoading', true)

        if (this.isCardValid) {
          const paymentPayload = {
            plan_id: this.$route.query.k,
            saude_id: this.$route.query.id,
            card: this.card,
            customer: this.customer
          }

          await this.$store.dispatch('comprarPlanoComCredito', paymentPayload)
          this.$router.push({name: 'voucherCartao', query: {id: this.$route.query.id}})
        } else {
          this.$store.dispatch('showPaymentErrorMsg', 'Cartão de crédito com informações incompletas ou inválidas')
        }
      } catch (error) {
        console.log(error.message)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    payment () {
      let id = this.$route.query.id
      this.$store.dispatch('getPedido', id)
        .then(pedido => {
          let agendamento = {}
          agendamento.rede = pedido.consulta.rede
          agendamento.especialidade = pedido.consulta.especialidade._id
          agendamento.corpoClinico = pedido.profissional
          agendamento.agenda = pedido.agendamento.agenda
          agendamento.user = pedido.cliente
          agendamento.dataEscolhida = pedido.agendamento.dataEscolhida
          agendamento.horarioEscolhido = pedido.agendamento.horarioEscolhido.horario
          this.$store.dispatch('saveAgendamento', agendamento)
            .then(agendamento => {
              this.$router.push({name: 'Voucher', query: {id}})
            })
        })
    },

    buildCustomer () {
      this.customer.first_name = this.cartao.client.name
      this.customer.last_name = this.cartao.client.name
      this.customer.taxpayer_id = this.cartao.client.cpf
      this.customer.description = this.cartao.client.name
      this.customer.email = this.cartao.client.email
      this.customer.address.line1 = this.cartao.client.enderecoResidencial || 'Sem informação de endereço residencial'
      this.customer.address.line2 = this.cartao.client.enderecoNumero || 'Sem informação de número residencial'
      this.customer.address.neighborhood = this.cartao.client.bairro || 'Sem informação de bairro'
      this.customer.address.city = this.cartao.client.cidade || 'Sem informação de cidade'
      this.customer.address.state = this.cartao.client.uf || 'RJ'
      this.customer.address.postal_code = this.cartao.client.cep || '20010000'
    },

    getDataFormatada (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD/MM/YYYY')
    }
  },

  mounted () {
    moment.locale('pt-br')

    const idSaude = this.$route.query.id
    this.$store.dispatch('getSaude', idSaude)
      .then(saudes => {
        this.cartao = saudes
        this.buildCustomer()
      })

    var $sticky = window.jQuery('.sticky')
    var $stickyrStopper = window.jQuery('.sticky-stopper')
    if ($sticky.offset()) { // make sure ".sticky" element exists
      var generalSidebarHeight = $sticky.innerHeight()
      var stickyTop = $sticky.offset().top
      var stickOffset = 0
      var stickyStopperPosition = $stickyrStopper.offset().top
      var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset
      var diff = stopPoint + stickOffset

      window.jQuery(window).scroll(function () { // scroll event
        var windowTop = window.jQuery(window).scrollTop() // returns number
        if (stopPoint < windowTop) {
          $sticky.css({ position: 'absolute', top: diff })
        } else if (stickyTop < windowTop + stickOffset) {
          $sticky.css({ position: 'fixed', top: stickOffset })
        } else {
          $sticky.css({position: 'absolute', top: 'initial'})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/pagamentos/CheckoutSinSaude.vue